module.exports = __webpack_public_path__ + "static/media/delete.02047567.svg";